
    import "src/app/AppAdmin/Billing/Pricing/index.module.scss?farm_css_modules";
    
    export default {"contentPage": `contentPage-bee22ec6`,"preferenceRow": `preferenceRow-bee22ec6`,"pricingDiv": `pricingDiv-bee22ec6`,"topHeader": `topHeader-bee22ec6`}
    